export interface SurveillanceAlert {
  id?: number;
  project: number;
  subject: string;
  result: string;
  description: string;
  conclusion: string;
  media_files?: File[];
  client_notified: boolean;
  notified_user?: number | null;
  timestamp?: string;
}

export interface SurveillanceAlertFormData {
  project: string;
  subject: string;
  result: string;
  description: string;
  conclusion: string;
  media_files?: FileList | null;
  client_notified: boolean;
  notified_user?: string;
  clientSelect?: string;
}

export interface ProjectClient {
  id: number;
  name: string;
}

export interface ClientUser {
  id: number;
  name: string;
  email?: string;
  job_title?: string;
}

export interface ProjectClientsResponse {
  clients: ProjectClient[];
}

export interface ClientUsersResponse {
  users: ClientUser[];
}

export const RESULT_CHOICES = [
  { value: 'Observed', label: 'Observed' },
  { value: 'Near Miss', label: 'Near Miss' },
  { value: 'Contacted Police', label: 'Contacted Police' },
] as const;

// Dashboard types
export interface AlertMedia {
  id: number;
  file: string;
  file_url: string;
  content_type: string;
  is_video: boolean;
  filename: string;
  uploaded_at: string;
}

export interface AlertUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  job_title?: string;
  full_name: string;
}

export interface AlertDetail extends SurveillanceAlert {
  user_info: AlertUser;
  notified_user_info?: AlertUser;
  media: AlertMedia[];
  media_count: number;
  formatted_timestamp: string;
}

export interface AlertsResponse {
  alerts: AlertDetail[];
  pagination: {
    count: number;
    num_pages: number;
    current_page: number;
    has_next: boolean;
    has_previous: boolean;
    page_size: number;
  };
  context: {
    client: {
      id: number;
      name: string;
    };
    project: {
      id: number;
      name: string;
    };
    projects: Array<{
      id: number;
      name: string;
    }>;
    result_choices: Array<[string, string]>;
    filters: {
      search_query: string;
      date_filter: string;
      result_filter: string;
    };
  };
}

